import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";

export function useExportRequisitions() {
  return useMutation({
    mutationFn: async () => {
      await guacHttpClient.post("exports/requisitions");
    },
  });
}
